package com.essntl.features.country.data.supabase

import com.essntl.features.country.domain.model.CountryModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun CountryModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["name"] = JsonPrimitive(name)

    return requestMap
}
